import router from './router'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import {getToken} from '@/utils/auth'
import {Company_getInfo} from "@/api/manage";
import {setDocumentTitle} from "@/utils/domUtil";
import appConfig from "@/config/appConfig"; // get token from cookie
const whiteList = ['/register','/login','/','/stampui','/modify'] // no redirect whitelist

NProgress.configure({ showSpinner: false }) // NProgress Configuration


// 路由守卫
router.beforeEach(async (to, from, next) => {
  // console.log(to,'to.meta++++++11111')
  // set page title
  document.title = appConfig.APP_TITLE
  const hasToken = localStorage.getItem("setToken")//getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/orderlist' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    if(to.path === '/'){
      next()
      NProgress.done()
    }else{
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next(`/login`)
        NProgress.done()
      }
    }

  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
